var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AhaInfoBox',[_vm._v("\n  Answers are not case-sensitive, e.g. “iPhone” and “iphone” are the same.\n  You can accept more answers while presenting.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }